import { Container } from "@mui/material";
import LazyImage from "components/LazyImage";
import { H3, Paragraph } from "components/Typography";
import { FlexBox } from "components/flex-box";
import { useIsMobile } from "hooks";
import { FC } from "react";

type Props = {
  image?: string;
  title?: string;
  subtitle?: string;
  width?: number;
  height?: number;
  noBackground?: boolean;
};

const NothingToShow: FC<Props> = ({
  image,
  title,
  subtitle,
  width = 250,
  height = 250,
  noBackground = false,
}) => {
  const isMobile = useIsMobile();
  return (
    <Container>
      <FlexBox
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        margin={"10vh"}
        textAlign={"center"}
      >
        <div
          style={{
            backgroundImage: noBackground
              ? "none"
              : `url('/assets/images/kachi/ellipseBG.png')`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <LazyImage src={image} width={width} height={height} />
        </div>
        <H3 mt={1}>{title}</H3>
        <Paragraph>{subtitle}</Paragraph>
      </FlexBox>
    </Container>
  );
};

export default NothingToShow;
